import { useFormContext, useWatch } from 'react-hook-form';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Service } from '@mews-commander/data-access';
import { CurrencyInputField } from '@mews-commander/form';
import { Stack, StackItem } from '@optimus-web/core';
import { AddProductFormValues, ServiceOrderFormField } from '../schema';
import { CurrencySelectField } from '../../../../../../components/form/hookFields';
import { useCurrencyFormat } from '../../../../../../core/globalization/hooks/useCurrencyFormat';

export const ServiceChargeFields = ({ service }: { service: Service }) => {
    const { hasOverridablePrice } = service.options;

    const { control } = useFormContext<AddProductFormValues>();
    const currency = useWatch({
        control,
        name: ServiceOrderFormField.Currency,
    });

    const currencyFormat = useCurrencyFormat(currency);

    return (
        <Stack spacing="200" fill>
            <StackItem grow>
                <CurrencyInputField
                    name={ServiceOrderFormField.Value}
                    label={lt(TextKey.AddServiceToReservationServiceChargeLabel)}
                    fixedDecimalScale
                    readOnly={!hasOverridablePrice}
                    {...currencyFormat}
                    precision={2}
                />
            </StackItem>
            <StackItem grow>
                <CurrencySelectField
                    currencyScope="currentEnterprise"
                    name={ServiceOrderFormField.Currency}
                    label={lt(TextKey.Currency)}
                    showEmptyValue={false}
                    readOnly={!hasOverridablePrice}
                />
            </StackItem>
        </Stack>
    );
};
